import { Link } from "react-router-dom";
import { articles, categories } from "@/mocks/articles";

export default function HeroSection() {
  const hotArticles = articles.filter((a) => a.isHot).slice(0, 3);

  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-end pb-16 md:pb-20">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20moody%20abstract%20background%20with%20dramatic%20warm%20amber%20and%20deep%20crimson%20gradient%20lighting%2C%20mysterious%20atmosphere%2C%20cinematic%20composition%2C%20subtle%20geometric%20patterns%2C%20luxury%20editorial%20style%2C%20rich%20textures%2C%20no%20text%2C%20no%20people&width=1920&height=900&seq=hero-bg-2026&orientation=landscape"
          alt=""
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/70"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="mb-8 md:mb-10">
            <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-4 whitespace-nowrap" style={{ fontFamily: "var(--font-heading)" }}>
              最新黑料爆料汇总平台
            </h1>
            <p className="text-base md:text-lg text-white/80 max-w-2xl leading-relaxed">
              汇聚全网热门黑料资讯，第一时间掌握娱乐圈、网红界最劲爆内幕信息，每日更新不间断
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
            {hotArticles.map((article, index) => (
              <Link
                key={article.id}
                to={`/article/${article.id}`}
                className="group block bg-white/10 backdrop-blur-md border border-white/20 rounded-xl p-5 md:p-6 hover:bg-white/20 transition-all duration-300 cursor-pointer"
              >
                <div className="flex items-center gap-2 mb-3">
                  <span className="px-2 py-0.5 bg-accent-500 text-background-50 text-xs font-medium rounded-full whitespace-nowrap">
                    热门爆料
                  </span>
                  <span className="text-white/60 text-xs whitespace-nowrap">{article.publishDate}</span>
                </div>
                <h3 className="text-white font-semibold text-base md:text-lg mb-2 line-clamp-2 group-hover:text-accent-300 transition-colors leading-snug">
                  {article.title}
                </h3>
                <p className="text-white/70 text-sm line-clamp-2 leading-relaxed">
                  {article.excerpt}
                </p>
                <div className="flex items-center gap-4 mt-4 text-white/50 text-xs">
                  <span className="flex items-center gap-1 whitespace-nowrap">
                    <i className="ri-eye-line"></i>
                    {article.viewCount >= 10000 ? `${(article.viewCount / 10000).toFixed(1)}万` : article.viewCount}
                  </span>
                  <span className="flex items-center gap-1 whitespace-nowrap">
                    <i className="ri-message-2-line"></i>
                    {article.commentCount}
                  </span>
                </div>
              </Link>
            ))}
          </div>

          <div className="flex flex-wrap items-center gap-3 mt-8">
            {categories.filter((c) => c.slug !== "all").map((cat) => (
              <Link
                key={cat.id}
                to={`/category/${cat.slug}`}
                className="px-4 py-2 bg-white/10 backdrop-blur-md border border-white/20 text-white text-sm rounded-full hover:bg-accent-500 hover:border-accent-500 transition-all duration-300 cursor-pointer whitespace-nowrap"
              >
                {cat.name}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}